// // components/Landing.jsx
// import React from "react";
// import { colors } from "../Color";
// //import heroImage from "../assets/hero.jpg"; // Make sure to add a hero.jpg in assets folder

// export default function Landing() {
//   return (
//     <section
//       className="flex flex-col md:flex-row justify-center items-center text-center md:text-left py-20 px-4 gap-10"
//       style={{ backgroundColor: colors.secondary }}
//     >
//       <div className="md:w-1/2">
//         <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
//           Empowering the Dairy Industry
//           <br />
//           with Smart Technology
//         </h2>
//         <p className="text-lg md:text-xl text-gray-700">
//           Innovative solutions for milk analysis, collection, and data
//           management.
//         </p>
//       </div>
//       <div className="md:w-1/2">
//         {/* <img
//           src={heroImage}
//           alt="Smart Dairy Tech"
//           className="rounded shadow-lg max-w-full"
//         /> */}
//       </div>
//     </section>
//   );
// }

////was working but need to chnage colour

// // components/Landing.jsx
// import React from "react";
// import { Award } from "lucide-react";
// import { colors } from "../Color";

// export default function Landing() {
//   return (
//     <section
//       id="home"
//       className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-24"
//       style={{ backgroundColor: colors.secondary }}
//     >
//       <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//         {/* Badge */}
//         <div className="mb-6">
//           <span className="inline-flex items-center px-4 py-2 bg-green-500 text-white text-sm font-medium rounded-full shadow">
//             <Award className="w-4 h-4 mr-2" />
//             ISO Certified • Nepal's Only Milk Analyzer Manufacturer
//           </span>
//         </div>

//         {/* Title */}
//         <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6">
//           Revolutionizing Nepal's <br />
//           <span className="text-green-400">Dairy Industry</span>
//         </h1>

//         {/* Description */}
//         <p className="text-lg md:text-2xl text-blue-100 mb-10 max-w-3xl mx-auto">
//           Leading manufacturer and distributor of ultrasonic milk analyzers and
//           dairy management software, providing high-precision testing equipment
//           and digital solutions.
//         </p>

//         {/* Buttons */}
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <button className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
//             Explore Our Products
//           </button>
//           <button className="border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
//             Contact Us Today
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// // components/Landing.jsx
// import React from "react";
// import { Award } from "lucide-react";
// import { colors } from "../Color";

// export default function Landing() {
//   return (
//     <section
//       id="home"
//       className="py-24"
//       style={{ backgroundColor: colors.primary, color: colors.secondary }}
//     >
//       <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//         {/* Badge */}
//         <div className="mb-6 inline-flex items-center px-4 py-2 bg-green-500 text-white text-sm font-medium rounded-full shadow">
//           <Award className="w-4 h-4 mr-2" />
//           ISO Certified • Nepal's Only Milk Analyzer Manufacturer
//         </div>

//         {/* Title */}
//         <h1
//           className="text-4xl md:text-6xl font-extrabold leading-tight mb-6"
//           style={{ color: colors.secondary }}
//         >
//           Revolutionizing Nepal's <br />
//           <span style={{ color: colors.accent }}>Dairy Industry</span>
//         </h1>

//         {/* Description */}
//         <p
//           className="text-lg md:text-2xl mb-10 max-w-3xl mx-auto"
//           style={{ color: colors.secondary }}
//         >
//           Leading manufacturer and distributor of ultrasonic milk analyzers and
//           dairy management software, providing high-precision testing equipment
//           and digital solutions.
//         </p>

//         {/* Buttons */}
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <button
//             className="px-8 py-4 rounded-lg text-lg font-semibold transition-colors"
//             style={{
//               backgroundColor: colors.accent,
//               color: colors.background,
//             }}
//             onMouseEnter={
//               (e) =>
//                 (e.currentTarget.style.backgroundColor =
//                   "#0099e6") /* slightly darker accent */
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.backgroundColor = colors.accent)
//             }
//           >
//             Explore Our Products
//           </button>
//           <button
//             className="border-2 px-8 py-4 rounded-lg text-lg font-semibold transition-colors"
//             style={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               backgroundColor: "transparent",
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.backgroundColor = colors.secondary;
//               e.currentTarget.style.color = colors.primary;
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.backgroundColor = "transparent";
//               e.currentTarget.style.color = colors.secondary;
//             }}
//           >
//             Contact Us Today
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

//scroll behaviour
import React from "react";
import { Award } from "lucide-react";
import { colors } from "../Color";

export default function Landing({ onExploreProducts, onContactUs }) {
  return (
    <section
      id="home"
      className="py-24"
      style={{ backgroundColor: colors.primary, color: colors.secondary }}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center px-4 py-2 bg-green-500 text-white text-sm font-medium rounded-full shadow">
          <Award className="w-4 h-4 mr-2" />
          ISO Certified • Nepal's Only Milk Analyzer Manufacturer
        </div>

        {/* Title */}
        <h1
          className="text-4xl md:text-6xl font-extrabold leading-tight mb-6"
          style={{ color: colors.secondary }}
        >
          Revolutionizing Nepal's <br />
          <span style={{ color: colors.accent }}>Dairy Industry</span>
        </h1>

        {/* Description */}
        <p
          className="text-lg md:text-2xl mb-10 max-w-3xl mx-auto"
          style={{ color: colors.secondary }}
        >
          Leading manufacturer and distributor of ultrasonic milk analyzers and
          dairy management software, providing high-precision testing equipment
          and digital solutions.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onExploreProducts}
            className="px-8 py-4 rounded-lg text-lg font-semibold transition-colors"
            style={{
              backgroundColor: colors.accent,
              color: colors.background,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#0099e6")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = colors.accent)
            }
          >
            Explore Our Products
          </button>
          <button
            onClick={onContactUs}
            className="border-2 px-8 py-4 rounded-lg text-lg font-semibold transition-colors"
            style={{
              borderColor: colors.secondary,
              color: colors.secondary,
              backgroundColor: "transparent",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colors.secondary;
              e.currentTarget.style.color = colors.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = colors.secondary;
            }}
          >
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
}
